import { React, useState, useEffect } from 'react';
import dayjs from 'dayjs';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import Fab from '@mui/material/Fab';
import ConfirmDialog from '../Modals/ConfirmDialog';
import { useSnackbar } from 'notistack';
import LoadingIndicator from '../LoadingIndicator'
import TokenService from '../../services/TokenService';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function CustomerNoteItem(props) {
    const [expanded, setExpanded] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    function truncate(str, n) {
        return (str.length > n) ? str.slice(0, n - 1) + '...' : str;
    };

    function showDeleteConfirmation() {
        setConfirmDialog({
            show: true,
            close: closeDeleteNote,
            title: 'Delete this note?',
            cancelText: 'Cancel',
            acceptText: 'Proceed',
            content: <div>
                <div>Do you want to delete the note for this customer?</div>
                <div style={{marginTop:'10px'} }>
                    {props.clientNote.Note}
                </div>
            </div>,
            data: ''
        });
    }

    function closeDeleteNote(didAccept) {
        if (didAccept) {
            setIsLoading(true);
            setConfirmDialog(null);
            let postData = {
                clientNoteId: props.clientNote.ClientNoteId
            }

            TokenService.adminServicePost(postData, 'Admin_DeleteCustomerNote', '')
                .then((response) => {
                    setIsLoading(false);
                    //response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        props.onDeleted(props.clientNote);
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Error in Add Customer Note', {
                        variant: 'error',
                    });
                    setIsLoading(false);
                });


        }
        else {
            setConfirmDialog(null);
        }
    }

    return <div componentname='CustomerNoteItem' style={{ maxWidth: '300px' }}>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} elevation={5}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
            >
                {isLoading ? <LoadingIndicator />
                    :
                    
                    expanded ?
                        <div style={{display:'flex'} }>
                            {props.clientNote.NoteType == 'Internal' ? null : <VisibilityIcon style={{ color: props.clientNote.ViewedDateTimeUTC == '0001-01-01T00:00:00' ? '#efefef' : 'var(--sipzee-green)' }} />}
                            <div style={{alignSelf:'center'} }>{props.clientNote.Note}</div>
                        </div>

                        :
                        <div style={{ display: 'flex' }}>
                            {props.clientNote.NoteType == 'Internal' ? null :
                                <VisibilityIcon style={{ color: props.clientNote.ViewedDateTimeUTC == '0001-01-01T00:00:00' ? '#efefef' : 'var(--sipzee-green)' }} />}
                                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '225px', width: '100%', whiteSpace: 'nowrap', alignSelf:'center' }}>{props.clientNote.Note}</div>
                        </div>
                }

                
            </AccordionSummary>
            <AccordionDetails>
                <div style={{ fontSize: '10pt', fontStyle: 'italic' }}>Added {dayjs(props.clientNote.InsertDateTimeUTC).format('MM/DD/YY')} by {props.clientNote.InsertedBy}</div>
                {
                    props.clientNote.NoteType == 'Internal' ? null :
                        <div>
                            {props.clientNote.ViewedDateTimeUTC == '0001-01-01T00:00:00' ?
                                <span>Not yet viewed</span>
                                :
                                <span>Viewed on {dayjs(props.clientNote.ViewedDateTimeUTC).format('MM/DD/YY')}</span>
                        }
                        </div>
                }
                <div style={{display:'flex', justifyContent:'flex-end'} }>
                    <Fab onClick={() => showDeleteConfirmation()} size={'small'}><DeleteIcon style={{ color: 'var(--sipzee-red)' }} /></Fab>
                </div>
            </AccordionDetails>
        </Accordion>
        <div>
           
        </div>
        {confirmDialog !== null ?
            <ConfirmDialog Close={confirmDialog.close} Title={confirmDialog.title} Content={confirmDialog.content} CancelText={confirmDialog.cancelText} AcceptText={confirmDialog.acceptText} Data={confirmDialog.data} />
            : null
        }
    </div>
}